// @flow
import React, { useCallback } from 'react';

import { OrderHistory } from 'app/common/components/Shop';


type Props = {
  params: {
    id: string,
    number: string,
  },
  push: (path: string) => void
}

const PaymentPage = ({ push }: Props) => {
  const onRedirectToCart = useCallback(() => {
    push('/shop/cart');
  }, [push]);

  return (
    <OrderHistory
      onRedirectToCart={onRedirectToCart}
    />
  );
};

export default PaymentPage;
